export function modalVisibleAction() {
    return {
        type: "IS_VISIBLE_MODAL",
    };
}
